import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Auth from "./pages/Auth";
import Main from "./containers/Main";
import firebase, { auth, database } from "./utils/firestoreConfig";
import { signInAnonymously } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import * as globalActions from "./redux/Global/actions";
import * as labelActions from "./redux/labelAndPlaceHolder/actions";

import "react-image-lightbox/style.css";
import "./assets/css/toast.css";
import "./assets/css/global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { bindActionCreators } from "redux";

import { authenticateUser } from "./redux/authentication/actions";
import { getAuthenticationCookie } from "./utils/authentication";

class App extends Component {
  componentDidMount() {
    this.checkToken();
    window.scrollTo(0, 0);

    signInAnonymously(auth).then(() => {
      const dbRef = ref(database);
      onValue(dbRef, (snapshot) => {
        this.props.actions.updateGlobalConfig(snapshot.val());
        this.props.action.fetchLabelsAndPlaceholder(snapshot.val());
      });
    });
  }

  checkToken = async () => {
    let authCredentials = await getAuthenticationCookie();
    if (authCredentials) this.props.authenticateUser(authCredentials);
  };

  render() {
    return (
      <div>
        <Switch>
          <Route path="/auth/:page" name="Auth" component={Auth} />
          <Route path="/" name="Main" component={Main} />
        </Switch>
        <div className="d-flex text-center">
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
          />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(globalActions, dispatch),
    action: bindActionCreators(labelActions, dispatch),
    authenticateUser: (payload) => dispatch(authenticateUser(payload)),
  };
}

function mapStateToProps(state) {
  return {
    country: state.Global.country,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
